import { useEffect } from 'react';
import { useProductRegistrationContext } from '@/product-registration/context';

// import api
import apiProductRegistrationProductsByTerm from '@/api/get/productRegistrationProductsByTerm';
import apiProductRegistrationProductsByCategoryCode from '@/api/get/productRegistrationProductsByCategoryCode';

const useFetchProducts = (hasValidSearchParams, searchParams) => {
  const [
    ,
    { setProductsLoading, unsetProductsLoading, setProducts },
  ] = useProductRegistrationContext();
  useEffect(() => {
    if (!hasValidSearchParams) return;
    const successCB = data => {
      setProducts(data);
      unsetProductsLoading();
    };
    const failCB = () => unsetProductsLoading();
    setProductsLoading();
    if (searchParams.text) {
      apiProductRegistrationProductsByTerm({
        term: searchParams.text,
        successCB,
        failCB,
      });
    }
    if (searchParams.category) {
      apiProductRegistrationProductsByCategoryCode({
        code: searchParams.category,
        successCB,
        failCB,
      });
    }
  }, [hasValidSearchParams, searchParams]);
};

export default useFetchProducts;
